import React, { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShopContext } from '../context/shopContext';

export default function SearchBar({ onDone, className = '' }) {
  const [term, setTerm] = useState('');
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const { searchProducts } = useContext(ShopContext);
  const navigate = useNavigate();
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!wrapRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const fetchSuggestions = async (q) => {
    if (q.trim().length > 2) {
      const results = await searchProducts(q);
      setSuggestions(results || []);
      setOpen(true);
    } else {
      setSuggestions([]);
      setOpen(false);
    }
  };

  const onChange = (e) => {
    const v = e.target.value;
    setTerm(v);
    fetchSuggestions(v);
  };

  const submit = () => {
    const q = term.trim();
    if (!q) return;
    navigate(`/search?query=${encodeURIComponent(q)}`);
    setOpen(false);
    onDone?.();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    submit();
  };

  const goToProduct = (product) => {
    navigate(`/product/${product.id.split('/').pop()}`);
    setOpen(false);
    onDone?.();
  };

  return (
    <div ref={wrapRef} className={`relative ${className}`}>
      <form onSubmit={onSubmit} className="relative flex items-center">
        <input
          type="text"
          inputMode='search'
          value={term}
          onChange={onChange}
          placeholder=""
          aria-label="Search products"
          className="w-full text-base font-light border border-gray-300 rounded-full px-4 py-2
                     focus:outline-none focus:ring-1 focus:ring-gray-400 mb-2"
        />
        <button
          type="submit"
          className="absolute right-3 text-sm italic py-1 px-2"
          aria-label="Search"
        >
          Search
        </button>
      </form>

      {open && suggestions.length > 0 && (
        <div className="absolute left-0 right-0 mt-1 z-[12000] bg-white border border-gray-200 shadow-md rounded-lg max-h-64 overflow-y-auto">
          {suggestions.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => goToProduct(p)}
              className="w-full text-left flex items-center gap-3 px-3 py-2 border-b last:border-0 hover:bg-gray-50"
            >
              <img
                src={p.images?.edges?.[0]?.node?.src || ''}
                alt={p.title}
                className="w-12 h-12 object-cover rounded-md"
                loading="lazy"
              />
              <div className="min-w-0">
                <p className="font-medium text-sm truncate">{p.title}</p>
                <p className="text-xs text-gray-500">
                  {Math.floor(p.variants?.edges?.[0]?.node?.price?.amount || 0)}{' '}
                  {p.variants?.edges?.[0]?.node?.price?.currencyCode || ''}
                </p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
